// TODO review
export const COLLECTION_LOOT_ALREADY_OPEN_ERROR = 'COLLECTION_LOOT_NOT_EXISTS';
